module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Calculator-e95d32a829b168bf4a818ea39204a98d.svg";